import { render, staticRenderFns } from "./versionManagementLookUp.vue?vue&type=template&id=8e3f4a50&scoped=true&"
import script from "./versionManagementLookUp.vue?vue&type=script&lang=js&"
export * from "./versionManagementLookUp.vue?vue&type=script&lang=js&"
import style0 from "./versionManagementLookUp.vue?vue&type=style&index=0&id=8e3f4a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f4a50",
  null
  
)

export default component.exports